var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTelecharger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.669 11.605a.75.75 0 0 1 .75.75v9.797a.75.75 0 1 1-1.5 0v-9.797a.75.75 0 0 1 .75-.75zm-8.863 12.552a.75.75 0 0 1 .75.75v3.698h16.22v-3.698a.75.75 0 0 1 1.5 0v4.448a.75.75 0 0 1-.75.75h-17.72a.75.75 0 0 1-.75-.75v-4.448a.75.75 0 0 1 .75-.75zm6.633-2.806a.75.75 0 0 0-.982 1.133l2.719 2.36a.75.75 0 0 0 .983 0l2.72-2.36a.75.75 0 0 0-.984-1.133l-2.228 1.933-2.228-1.933z",
    fill: "#1D1D1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelecharger);
export default __webpack_public_path__ + "static/media/icon-telecharger.4e20c307.svg";
export { ForwardRef as ReactComponent };